export const MODAL_NAMES = {
  GIFT_CARDS_FAQ: 'GIFT_CARDS_FAQ',
}
